import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/checked-white.svg'


const _hoisted_1 = { class: "admin-page-wr" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-header"
}
const _hoisted_3 = { class: "subtitle-main" }
const _hoisted_4 = {
  key: 1,
  class: "filters"
}
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = { class: "button default primary add-btn-primary bulk-btn" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "table-controls"
}
const _hoisted_9 = {
  key: 0,
  class: "items-count"
}
const _hoisted_10 = {
  key: 1,
  class: "items-count"
}
const _hoisted_11 = { class: "table-default" }
const _hoisted_12 = {
  key: 0,
  class: "checkbox"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "bold" }
const _hoisted_16 = { class: "tooltip-container" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 3,
  class: "content-checked"
}
const _hoisted_20 = {
  key: 0,
  class: "tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.isConciergeView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "title-main" }, "Lots", -1)),
          _createElementVNode("h3", _hoisted_3, _toDisplayString(`${$setup.lots.length} lot${$setup.lots.length > 1 ? "s" : ""}`), 1)
        ]))
      : _createCommentVNode("", true),
    (!$props.isConciergeView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode($setup["InputSearch"], {
            modelValue: $setup.searchQuery,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
            placeholder: "Search",
            theme: "filter"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "button default primary add-btn-primary",
              onClick: $setup.toCreateLot
            }, "Add Lot"),
            _createElementVNode("label", _hoisted_6, [
              _cache[10] || (_cache[10] = _createTextVNode("Bulk Upload Lots", -1)),
              _createElementVNode("input", {
                class: "bulk-input",
                type: "file",
                onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.bulkUpload($event))),
                accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              }, null, 32)
            ]),
            ($setup.templateDownloadLink)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "button default primary",
                  href: $setup.templateDownloadLink,
                  target: "_blank"
                }, "Download Template", 8, _hoisted_7))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["table-wrapper", { 'with-checkbox': !$setup.isUserActive }])
    }, [
      (!$setup.isUserActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            ($setup.selectedLotsList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.plural($setup.selectedLotsList.length, "lot")) + " selected", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.plural($setup.lots.length, "lot")), 1)),
            _createElementVNode("button", {
              class: _normalizeClass(["table-controls-button delete", { show: $setup.selectedLotsList.length > 0 }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showConfirmBulkDeleteModal = true))
            }, "Delete lots", 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_11, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (!$setup.isUserActive)
              ? (_openBlock(), _createElementBlock("th", _hoisted_12, [
                  _createVNode($setup["CheckboxInput"], {
                    checkedPartial: $setup.selectedLotsList.length > 0 && $setup.selectedLotsList.length !== $setup.lotList.length,
                    modelValue: $setup.isSelectAll,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.selectAll($event)))
                  }, null, 8, ["checkedPartial", "modelValue"])
                ]))
              : _createCommentVNode("", true),
            _cache[11] || (_cache[11] = _createElementVNode("th", null, "Lot №", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("th", null, "Street Name", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("th", null, "Size", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("th", null, "Price", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("th", null, "Status", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("th", null, "Action", -1))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lots, (lot, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              onClick: ($event: any) => ($setup.handleRowClick(lot, index))
            }, [
              (!$setup.isUserActive)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    class: "checkbox",
                    onClick: _withModifiers(($event: any) => ($setup.selectLot(!$setup.lotList[index].selected, index)), ["stop"])
                  }, [
                    _createVNode($setup["CheckboxInput"], {
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                      modelValue: $setup.lotList[index].selected,
                      "onUpdate:modelValue": ($event: any) => ($setup.selectLot($event, index))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ], 8, _hoisted_14))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_15, "Lot " + _toDisplayString(lot.title), 1),
              _createElementVNode("td", null, _toDisplayString(lot.streetName || "--"), 1),
              _createElementVNode("td", null, _toDisplayString($setup.formatPrice(lot.size, false)), 1),
              _createElementVNode("td", null, _toDisplayString($setup.formatPrice(lot.price)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["badge", $setup.getLotStatusClass(lot.status === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : lot.status)])
                }, _toDisplayString(lot.status === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : lot.status), 3)
              ]),
              _createElementVNode("td", {
                class: _normalizeClass(["actions", { 'max-width': $props.isConciergeView }])
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["actions-wr", { checked: $setup.lotList[index].selected }])
                  }, [
                    (!$props.isConciergeView)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: _normalizeClass(["icon edit", { disabled: !$setup.canEditLot(lot.status) }]),
                          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                          to: { name: 'AdminLotUpdate', params: { userId: $setup.userId, estateId: $setup.estateId, stageId: $setup.stageId, lotId: lot._id } }
                        }, null, 8, ["to", "class"]))
                      : _createCommentVNode("", true),
                    (!$props.isConciergeView)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "icon trash",
                          onClick: _withModifiers(($event: any) => ($setup.setItemForDelete(lot)), ["stop"])
                        }, null, 8, _hoisted_17))
                      : _createCommentVNode("", true),
                    ($props.isConciergeView && !$setup.lotList[index].selected)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: _normalizeClass(["badge select", { 'disabled-lot': lot.status !== $setup.LotStatus.AVAILABLE || lot.builders.length <= 0 }]),
                          disabled: lot.status !== $setup.LotStatus.AVAILABLE || lot.builders.length <= 0
                        }, _toDisplayString($setup.getButtonLabel(lot, index)), 11, _hoisted_18))
                      : _createCommentVNode("", true),
                    ($props.isConciergeView && $setup.lotList[index].selected)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("img", {
                            class: "icon-checked",
                            src: _imports_0
                          }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ], 2),
                  ((lot.status !== $setup.LotStatus.AVAILABLE || lot.builders.length <= 0) && $setup.props.isConciergeView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, "This lot is disabled because it is not available or because it has no builders associated with it."))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ], 8, _hoisted_13))
          }), 256))
        ])
      ])
    ], 2),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.showConfirmDeleteModal,
      deleteItem: $setup.itemForDelete.title,
      onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.showConfirmDeleteModal = false)),
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => ($setup.deleteLot($setup.itemForDelete.id)))
    }, null, 8, ["isOpen", "deleteItem"]),
    (!$setup.isUserActive)
      ? (_openBlock(), _createBlock($setup["ConfirmDeleteModal"], {
          key: 2,
          isOpen: $setup.showConfirmBulkDeleteModal,
          deleteItem: $setup.selectedLotsList.length > 1 ? 'selected lots' : 'selected lot',
          onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.showConfirmBulkDeleteModal = false)),
          onConfirm: $setup.bulkDeleteLots
        }, null, 8, ["isOpen", "deleteItem"]))
      : _createCommentVNode("", true)
  ]))
}